module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAeCAIAAABBgHAAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEdJREFUeNrs0QEJAAAAwjDB/p3NIewRvkbn1QKEQiiECIVQCIUQoRAKoRAiFEIhFEKEQiiEQohQCIVQCBEKoRAKIUL9NQEGAM76AFtBeHrnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_minus_black.png
// module id = 585
// module chunks = 0